import http from "../../http-common";
/* eslint-disable */
class SliderService {
  sliderList(page, itemPerPage, keyword) {
    return http.get(
      "/slider/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("deskripsi", data.deskripsi);

    if (data.selectedHide && data.selectedHide != undefined) {
      bodyFormData.append("publish", data.selectedHide.text);
    }

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/slider", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("deskripsi", data.deskripsi);

    if (data.selectedHide && data.selectedHide != undefined) {
      bodyFormData.append("publish", data.selectedHide.text);
    }

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/slider/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/slider/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new SliderService();
